import React, { useState, useEffect } from "react"
import {
    Button,
    Flex,
    Heading,
    Text,
    TextField,
    RadioGroup,
    Radio,
    View,
    Content,
    DialogTrigger,
    Dialog,
    Divider,
    TextArea,
    Well,
    TooltipTrigger,
    Tooltip,
    ActionButton,
    Picker,
    Item,
    Switch,
} from "@adobe/react-spectrum"
import Email from "@spectrum-icons/workflow/Email"
import Close from "@spectrum-icons/workflow/Close"
import Chat from "@spectrum-icons/workflow/Chat"
import Delete from "@spectrum-icons/workflow/Delete"
import { SlackIcon, EmailIcon } from "../../utilities/components/Icons"

const CustomTemplate = ({ onSave, initialData, isEditable, onClose, templateData , alertName}) => {
    // console.log("templateData from CustomTemplate.jsx", templateData)
    // console.log("initialData from CustomTemplate.jsx", initialData)
    // console.log("isEditable from CustomTemplate.jsx", isEditable)
    // const lines = templateData.body.split("\n").filter(Boolean)
    // const openingStatement = lines[0]
    // const closingStatement = lines[lines.length - 1]
    // const caseData = lines.slice(2, lines.length - 1)
    // const subject = templateData.subject

    const attributesDropdown = templateData?.templateAttributes || []

    function getOpeningClosingAndAttributes(string) {
        const lines = string?.split(/\r?\n/)?.map(line => line?.trim())?.filter(line => line !== "");
        
          const fieldPattern = /^[\w\s]+:\s*\{.*\}$/; // e.g. Case ID: {CASEIDLINK}
        
          let opening = [];
          let mid = [];
          let closing = [];
        
          let phase = "opening";
        
          for (let i = 0; i < lines?.length; i++) {
            const line = lines[i];
        
            if (phase === "opening" && fieldPattern.test(line)) {
              phase = "mid";
            }
        
            if (phase === "mid" && !fieldPattern.test(line)) {
              phase = "closing";
            }
        
            if (phase === "opening") {
              opening.push(line);
            } else if (phase === "mid") {
              mid.push(line);
            } else {
              closing.push(line);
            }
          }
        //   console.log("OPENING: \n", opening.join("\n"));
        //   console.log("MID: \n", mid);
        //   console.log("CLOSING: \n", closing.join("\n"));

          const openingStatement = opening.join("\n")
          const midStatement = mid
          const closingStatement = closing.join("\n")

          return { openingStatement, midStatement, closingStatement }
    }
    
    // const ensureValidAttributeValue = (value) => {
    //     if (!value) return attributesDropdown.length > 0 ? attributesDropdown[0].attributeValue : "";
    //     const exists = attributesDropdown.some(attr => attr.attributeValue === value);
    //     return exists ? value : (attributesDropdown.length > 0 ? attributesDropdown[0].attributeValue : "");
    // };
    
    // const emailAttributes = caseData.map(line => {
    //     const [label, ...rest] = line.split(":")
    //     const value = rest.join(":").trim()
    //     return { 
    //         attributeName: label.trim(), 
    //         attributeValue: ensureValidAttributeValue(value)
    //     }
    // })

    // const slackAttributes = caseData.map(line => {
    //     const [label, ...rest] = line.split(":")
    //     const value = rest.join(":").trim()
    //     return { 
    //         attributeName: label.trim(), 
    //         attributeValue: ensureValidAttributeValue(value)
    //     }
    // })

    const [templateType, setTemplateType] = useState(initialData?.common ? "common" : "individual")
    const [formData, setFormData] = useState({
        subject: "",
        openingStatement: "",
        closingStatement: "",
        emailOpeningStatement: "",
        emailClosingStatement: "",
        slackOpeningStatement: "",
        slackClosingStatement: "",
        attributes: [],
        emailAttributes: [],
        slackAttributes: [],
        slackReply: false,
        slackReplyMessage: "",
    })

    const [isValid, setIsValid] = useState(true);

    const validateAttributes = (attributes) => {
        return attributes.every(attr => 
            attr.attributeName && attr.attributeName.trim() !== '' && 
            attr.attributeValue && attr.attributeValue.trim() !== ''
        );
    };

    const validateForm = () => {
        if (templateType === "common") {
            const isValidCommon = validateAttributes(formData.attributes);
            const isValidSubject = formData.subject.trim() !== '';
            const isValidOpening = formData.openingStatement.trim() !== '';
            setIsValid(isValidCommon && isValidSubject && isValidOpening);
        } else {
            const isValidEmail = validateAttributes(formData.emailAttributes);
            const isValidSlack = validateAttributes(formData.slackAttributes);
            const isValidSubject = formData.subject.trim() !== '';
            const isValidEmailOpening = formData.emailOpeningStatement.trim() !== '';
            const isValidSlackOpening = formData.slackOpeningStatement.trim() !== '';
            setIsValid(isValidEmail && isValidSlack && isValidSubject && isValidEmailOpening && isValidSlackOpening);
        }
    };

    useEffect(() => {
        validateForm();
    }, [formData.subject, formData.openingStatement, formData.emailOpeningStatement, formData.slackOpeningStatement, formData.attributes, formData.emailAttributes, formData.slackAttributes, templateType]);

    useEffect(() => {
        const isInitialDataEmpty = initialData.emailBody === "" && initialData.slackMessage === "" && initialData.emailSubject === ""
        const movingFromDefaultToCustom = initialData?.custom === false
        if (isEditable && Object.keys(initialData).length > 0 && !isInitialDataEmpty && !movingFromDefaultToCustom) {
            // console.log("inside useEffect")
            const { openingStatement, midStatement, closingStatement } = getOpeningClosingAndAttributes(initialData.emailBody)
            // const emailLines = initialData.emailBody?.split("\n").filter(Boolean) || []
            const emailOpeningStatement = openingStatement || ""
            const emailClosingStatement = closingStatement || ""
            const emailCaseData = midStatement
            
            const emailAttributes = emailCaseData.map(line => {
                const [label, ...rest] = line.split(":")
                const value = rest.join(":").trim()
                return { 
                    attributeName: label.trim(), 
                    attributeValue: value
                }
            })

            if (initialData.common) {
                setFormData(prev => ({
                    ...prev,
                    subject: initialData.emailSubject || "",
                    openingStatement: emailOpeningStatement,
                    closingStatement: emailClosingStatement,
                    emailOpeningStatement: emailOpeningStatement,
                    emailClosingStatement: emailClosingStatement,
                    slackOpeningStatement: emailOpeningStatement,
                    slackClosingStatement: emailClosingStatement,
                    attributes: emailAttributes,
                    emailAttributes: emailAttributes,
                    slackAttributes: emailAttributes,
                    slackReply: initialData.slackReply || false,
                    slackReplyMessage: initialData.slackReplyMessage || "",
                }))
                setTemplateType("common")
            } else {
                // console.log("inside else")
                const { openingStatement, midStatement, closingStatement } = getOpeningClosingAndAttributes(initialData.slackMessage)

                // const slackLines = initialData.slackMessage?.split("\n").filter(Boolean) || []
                const slackOpeningStatement = openingStatement|| ""
                const slackClosingStatement = closingStatement || ""
                const slackCaseData = midStatement
                
                const slackAttributes = slackCaseData.map(line => {
                    const [label, ...rest] = line.split(":")
                    const value = rest.join(":").trim()
                    return { 
                        attributeName: label.trim(), 
                        attributeValue: value
                    }
                })

                setFormData(prev => ({
                    ...prev,
                    subject: initialData.emailSubject || "",
                    emailOpeningStatement: emailOpeningStatement,
                    emailClosingStatement: emailClosingStatement,
                    slackOpeningStatement: slackOpeningStatement,
                    slackClosingStatement: slackClosingStatement,
                    emailAttributes: emailAttributes,
                    slackAttributes: slackAttributes,
                    slackReply: initialData.slackReply || false,
                    slackReplyMessage: initialData.slackReplyMessage || "",
                }))
                setTemplateType("individual")
            }
        } else if (templateData) {
            // console.log("inside else if")
            const { openingStatement, midStatement, closingStatement } = getOpeningClosingAndAttributes(templateData.body)
            // const lines = templateData.body?.split("\n").filter(Boolean) || []
            const addedOpeningStatement = openingStatement || ""
            const addedClosingStatement = closingStatement || ""
            const addedCaseData = midStatement
            
            const attributes = addedCaseData.map(line => {
                const [label, ...rest] = line.split(":")
                const value = rest.join(":").trim()
                return { 
                    attributeName: label.trim(), 
                    attributeValue: value
                }
            })

            setFormData(prev => ({
                ...prev,
                subject: templateData.subject || "",
                openingStatement: addedOpeningStatement,
                closingStatement: addedClosingStatement,
                emailOpeningStatement: addedOpeningStatement,
                emailClosingStatement: addedClosingStatement,
                slackOpeningStatement: addedOpeningStatement,
                slackClosingStatement: addedClosingStatement,
                attributes: attributes,
                emailAttributes: attributes,
                slackAttributes: attributes
            }))
            setTemplateType("common")
        }
    }, [isEditable, initialData, templateData])

    useEffect(() => {
        if (templateType === "common") {
            setFormData(prev => ({
                ...prev,
                openingStatement: prev.emailOpeningStatement,
                closingStatement: prev.emailClosingStatement,
                attributes: prev.emailAttributes
            }))
        }
    }, [templateType])

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }))
    }

    const handleAttributeChange = (index, field, value, attributeType = 'common') => {
        setFormData(prev => {
            const attributes = attributeType === 'common' ? prev.attributes : 
                             attributeType === 'email' ? prev.emailAttributes : 
                             prev.slackAttributes;
            
            const newAttributes = [...attributes];
            if (index >= newAttributes.length) {
                newAttributes.push({ attributeName: '', attributeValue: '' });
            }
            newAttributes[index] = {
                ...newAttributes[index],
                [field]: value
            };

            return {
                ...prev,
                [attributeType === 'common' ? 'attributes' : 
                 attributeType === 'email' ? 'emailAttributes' : 'slackAttributes']: newAttributes
            };
        });
    }

    const handleAddAttribute = (attributeType = 'common') => {
        setFormData(prev => {
            const attributes = attributeType === 'common' ? prev.attributes : 
                             attributeType === 'email' ? prev.emailAttributes : 
                             prev.slackAttributes;
            
            return {
                ...prev,
                [attributeType === 'common' ? 'attributes' : 
                 attributeType === 'email' ? 'emailAttributes' : 'slackAttributes']: [
                    ...attributes,
                    { attributeName: '', attributeValue: '' }
                ]
            };
        });
    }

    const handleRemoveAttribute = (index, attributeType = 'common') => {
        setFormData(prev => {
            const attributes = attributeType === 'common' ? prev.attributes : 
                             attributeType === 'email' ? prev.emailAttributes : 
                             prev.slackAttributes;
            
            const newAttributes = [...attributes];
            newAttributes.splice(index, 1);

            return {
                ...prev,
                [attributeType === 'common' ? 'attributes' : 
                 attributeType === 'email' ? 'emailAttributes' : 'slackAttributes']: newAttributes
            };
        });
    }

    const handleSaveTemplate = () => {
        const templateData = {
            templateType,
            common: templateType === "common",
            emailSubject: formData.subject,
            emailBody: templateType === "common" 
                ? `${formData.openingStatement}\n\n${formData.attributes.map(attr => `${attr.attributeName}: ${attr.attributeValue}`).join("\n")}\n\n${formData.closingStatement}`
                : `${formData.emailOpeningStatement}\n\n${formData.emailAttributes.map(attr => `${attr.attributeName}: ${attr.attributeValue}`).join("\n")}\n\n${formData.emailClosingStatement}`,
            slackMessage: templateType === "common"
                ? `${formData.openingStatement}\n\n${formData.attributes.map(attr => `${attr.attributeName}: ${attr.attributeValue}`).join("\n")}\n\n${formData.closingStatement}`
                : `${formData.slackOpeningStatement}\n\n${formData.slackAttributes.map(attr => `${attr.attributeName}: ${attr.attributeValue}`).join("\n")}\n\n${formData.slackClosingStatement}`,
            emailAttributes: templateType === "common" ? formData.attributes : formData.emailAttributes,
            slackAttributes: templateType === "common" ? formData.attributes : formData.slackAttributes,
            slackReply: formData.slackReply || false,
            slackReplyMessage: formData.slackReplyMessage || "",
        }
        onSave(templateData)
    }

    const handleCancel = () => {
        onClose()
    }

    const handleDeleteAllAttributes = () => {
        setFormData((prev) => ({ ...prev, attributes: [] }))
    }

    const handleDeleteEmailAttributes = () => {
        setFormData((prev) => ({ ...prev, emailAttributes: [] }))
    }

    const handleDeleteSlackAttributes = () => {
        setFormData((prev) => ({ ...prev, slackAttributes: [] }))
    }

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return (
        <DialogTrigger isOpen={true}>
            <div></div>
            <Dialog width="95vw" height="90vh">
                <Content UNSAFE_style={{ padding: 0 }}>
                    <Flex direction="column" gap="size-200">
                        <View
                            UNSAFE_style={{
                                top: 0,
                                position: "sticky",
                                backgroundColor: "white",
                                zIndex: 1000,
                                padding: "0px 20px 0px 20px",
                            }}
                        >
                            <Flex
                                justifyContent="space-between"
                                alignItems="center"
                                marginBottom="size-200"
                            >
                                <Heading level={3} margin={0}>
                                    Edit template for {capitalizeFirstLetter(alertName)} Alert
                                </Heading>
                                <Flex justifyContent="end" gap="size-200">
                                    <Button
                                        variant="secondary"
                                        onPress={handleCancel}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="cta"
                                        onPress={handleSaveTemplate}
                                        isDisabled={!isValid}
                                    >
                                        Save Changes
                                    </Button>
                                </Flex>
                            </Flex>
                            <Divider size="S" />

                            <Flex
                                alignItems="center"
                                gap="size-200"
                                UNSAFE_style={{
                                    width: "100%",
                                    padding: "size-100",
                                }}
                            >
                                <Text>Template used for</Text>
                                <RadioGroup
                                    orientation="horizontal"
                                    value={templateType}
                                    onChange={setTemplateType}
                                    isEmphasized
                                    UNSAFE_style={{
                                        marginTop: "10px",
                                    }}
                                >
                                    <Radio value="individual">Individual</Radio>
                                    <Radio value="common">Common</Radio>
                                </RadioGroup>
                                <Divider
                                    size="S"
                                    orientation="vertical"
                                    marginBottom={"10px"}
                                />
                                <Text UNSAFE_style={{ fontWeight: "bold" }}>
                                    Note:
                                </Text>
                                <Text>
                                    Use Attribute value e.g. {"{CASE_ID}"},{" "}
                                    {"{ORG_ID}"} etc in the input fields between
                                    the normal text to get the runtime value.
                                </Text>
                            </Flex>
                        </View>

                        <Flex
                            gap="size-400"
                            wrap
                            UNSAFE_style={{
                                backgroundColor: "#E6E6E6",
                                padding: "20px 0px 20px 20px",
                                minHeight: "68vh",
                            }}
                        >
                            <View flex="1">
                                {templateType === "common" ? (
                                    <View
                                        UNSAFE_style={{
                                            borderRadius: "10px",
                                            backgroundColor: "white",
                                            padding: "20px",
                                            boxShadow:
                                                "0 2px 8px rgba(0,0,0,0.08)",
                                        }}
                                    >
                                        <Flex
                                            alignItems="center"
                                            gap="size-200"
                                            marginBottom="size-200"
                                        >
                                            <Heading level={5} margin={0}>
                                                Email and Slack Template
                                            </Heading>
                                        </Flex>
                                        <TextField
                                            label="Subject of the mail"
                                            value={formData.subject}
                                            onChange={(v) =>
                                                handleInputChange("subject", v)
                                            }
                                            width="100%"
                                            marginBottom="size-200"
                                            isRequired
                                            necessityIndicator="label"
                                        />
                                        <TextArea
                                            label="Opening statement"
                                            value={formData.openingStatement}
                                            onChange={(v) =>
                                                handleInputChange(
                                                    "openingStatement",
                                                    v
                                                )
                                            }
                                            width="100%"
                                            marginBottom="size-200"
                                            isRequired
                                            necessityIndicator="label"
                                        />

                                        <Flex
                                            justifyContent="space-between"
                                            alignItems="center"
                                        >
                                            <Heading
                                                level={6}
                                                marginTop="size-200"
                                                marginBottom="size-100"
                                            >
                                                Attributes
                                            </Heading>

                                            <TooltipTrigger delay={0}>
                                                <ActionButton
                                                    isQuiet
                                                    onPress={
                                                        handleDeleteAllAttributes
                                                    }
                                                >
                                                    <Delete />
                                                </ActionButton>
                                                <Tooltip>
                                                    Delete All Attributes
                                                </Tooltip>
                                            </TooltipTrigger>
                                        </Flex>

                                        {formData.attributes.map(
                                            (attr, index) => (
                                                <Flex
                                                    key={index}
                                                    gap="size-200"
                                                    marginY="size-100"
                                                    width="100%"
                                                    alignItems="center"
                                                >
                                                    <TextField
                                                        width="40%"
                                                        value={attr.attributeName}
                                                        onChange={(v) =>
                                                            handleAttributeChange(index, 'attributeName', v, 'common')
                                                        }
                                                    />
                                                    <Picker
                                                        width="40%"
                                                        selectedKey={attr.attributeValue}
                                                        onSelectionChange={(v) =>
                                                            handleAttributeChange(index, 'attributeValue', v, 'common')
                                                        }
                                                    >
                                                        {attributesDropdown.map((dropdownAttr) => (
                                                            <Item key={dropdownAttr.attributeValue}>{dropdownAttr.attributeValue}</Item>
                                                        ))}
                                                    </Picker>
                                                    <Button
                                                        variant="secondary"
                                                        onPress={() =>
                                                            handleRemoveAttribute(index, 'common')
                                                        }
                                                        UNSAFE_style={{
                                                            border:
                                                                "transparent",
                                                            minWidth: "32px",
                                                            height: "32px",
                                                            padding: 0,
                                                        }}
                                                        aria-label="Remove attribute"
                                                    >
                                                        <Close
                                                            UNSAFE_style={{
                                                                transform:
                                                                    "scale(0.8)",
                                                            }}
                                                        />
                                                    </Button>
                                                </Flex>
                                            )
                                        )}

                                        <Button
                                            variant="primary"
                                            marginTop="size-200"
                                            marginBottom="size-300"
                                            onPress={() => handleAddAttribute('common')}
                                        >
                                            Add Attribute
                                        </Button>
                                        <TextArea
                                            label="Closing statement"
                                            value={formData.closingStatement}
                                            onChange={(v) =>
                                                handleInputChange(
                                                    "closingStatement",
                                                    v
                                                )
                                            }
                                            width="100%"
                                        />
                                        <Divider size="S" marginTop="size-300" marginBottom="size-200" />
                                        <Flex alignItems="center" gap="size-200" marginBottom="size-200">
                                            <SlackIcon />
                                            <Text>Reply in Slack thread</Text>
                                            <Switch
                                                isSelected={formData.slackReply}
                                                onChange={(v) => handleInputChange("slackReply", v)}
                                            />
                                        </Flex>
                                        {formData.slackReply && (
                                            <TextArea
                                                label="Slack reply message"
                                                value={formData.slackReplyMessage}
                                                onChange={(v) => handleInputChange("slackReplyMessage", v)}
                                                width="100%"
                                            />
                                        )}
                                    </View>
                                ) : (
                                    <>
                                        <View
                                            marginBottom="size-400"
                                            UNSAFE_style={{
                                                borderRadius: "10px",
                                                backgroundColor: "white",
                                                padding: "20px",
                                                boxShadow:
                                                    "0 2px 8px rgba(0,0,0,0.08)",
                                            }}
                                        >
                                            <Flex
                                                alignItems="center"
                                                gap="size-200"
                                                marginBottom="size-200"
                                            >
                                                <EmailIcon />
                                                <Heading level={5} margin={0}>
                                                    Email Template
                                                </Heading>
                                            </Flex>
                                            <TextField
                                                label="Subject of the mail"
                                                value={formData.subject}
                                                onChange={(v) =>
                                                    handleInputChange(
                                                        "subject",
                                                        v
                                                    )
                                                }
                                                width="100%"
                                                marginBottom="size-200"
                                                isRequired
                                                necessityIndicator="label"
                                            />
                                            <TextArea
                                                label="Email opening statement"
                                                value={
                                                    formData.emailOpeningStatement
                                                }
                                                onChange={(v) =>
                                                    handleInputChange(
                                                        "emailOpeningStatement",
                                                        v
                                                    )
                                                }
                                                width="100%"
                                                marginBottom="size-200"
                                                isRequired
                                                necessityIndicator="label"
                                            />

                                            <Flex
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Heading
                                                    level={6}
                                                    marginTop="size-200"
                                                    marginBottom="size-100"
                                                >
                                                    Email Attributes
                                                </Heading>
                                                
                                                <TooltipTrigger delay={0}>
                                                    <ActionButton
                                                        isQuiet
                                                        onPress={handleDeleteEmailAttributes}
                                                    >
                                                        <Delete />
                                                    </ActionButton>
                                                    <Tooltip>
                                                        Delete All Email Attributes
                                                    </Tooltip>
                                                </TooltipTrigger>
                                            </Flex>
                                            {formData.emailAttributes.map(
                                                (attr, index) => (
                                                    <Flex
                                                        key={index}
                                                        gap="size-200"
                                                        marginY="size-100"
                                                        alignItems="center"
                                                    >
                                                        <TextField
                                                            width="40%"
                                                            value={attr.attributeName}
                                                            onChange={(v) =>
                                                                handleAttributeChange(index, 'attributeName', v, 'email')
                                                            }
                                                        />
                                                        <Picker
                                                            width="40%"
                                                            selectedKey={attr.attributeValue}
                                                            onSelectionChange={(v) =>
                                                                handleAttributeChange(index, 'attributeValue', v, 'email')
                                                            }
                                                        >
                                                            {attributesDropdown.map((dropdownAttr) => (
                                                                <Item key={dropdownAttr.attributeValue}>{dropdownAttr.attributeValue}</Item>
                                                            ))}
                                                        </Picker>
                                                        <Button
                                                            variant="secondary"
                                                            onPress={() =>
                                                                handleRemoveAttribute(index, 'email')
                                                            }
                                                            UNSAFE_style={{
                                                                border:
                                                                    "transparent",
                                                                minWidth:
                                                                    "32px",
                                                                height: "32px",
                                                                padding: 0,
                                                            }}
                                                            aria-label="Remove attribute"
                                                        >
                                                            <Close
                                                                UNSAFE_style={{
                                                                    transform:
                                                                        "scale(0.8)",
                                                                }}
                                                            />
                                                        </Button>
                                                    </Flex>
                                                )
                                            )}

                                            <Button
                                                variant="primary"
                                                marginTop="size-200"
                                                marginBottom="size-300"
                                                onPress={() => handleAddAttribute('email')}
                                            >
                                                Add Email Attribute
                                            </Button>

                                            <TextArea
                                                label="Email closing statement"
                                                value={
                                                    formData.emailClosingStatement
                                                }
                                                onChange={(v) =>
                                                    handleInputChange(
                                                        "emailClosingStatement",
                                                        v
                                                    )
                                                }
                                                width="100%"
                                            />
                                        </View>

                                        <View
                                            UNSAFE_style={{
                                                borderRadius: "10px",
                                                backgroundColor: "white",
                                                padding: "20px",
                                                boxShadow:
                                                    "0 2px 8px rgba(0,0,0,0.08)",
                                            }}
                                        >
                                            <Flex
                                                alignItems="center"
                                                gap="size-200"
                                                marginBottom="size-200"
                                            >
                                                <SlackIcon />
                                                <Heading level={5} margin={0}>
                                                    Slack Template
                                                </Heading>
                                            </Flex>
                                            <TextArea
                                                label="Slack opening statement"
                                                value={
                                                    formData.slackOpeningStatement
                                                }
                                                onChange={(v) =>
                                                    handleInputChange(
                                                        "slackOpeningStatement",
                                                        v
                                                    )
                                                }
                                                width="100%"
                                                marginBottom="size-200"
                                                isRequired
                                                necessityIndicator="label"
                                            />

                                            <Flex
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Heading
                                                    level={6}
                                                    marginTop="size-200"
                                                    marginBottom="size-100"
                                                >
                                                    Slack Attributes
                                                </Heading>
                                                
                                                <TooltipTrigger delay={0}>
                                                    <ActionButton
                                                        isQuiet
                                                        onPress={handleDeleteSlackAttributes}
                                                    >
                                                        <Delete />
                                                    </ActionButton>
                                                    <Tooltip>
                                                        Delete All Slack Attributes
                                                    </Tooltip>
                                                </TooltipTrigger>
                                            </Flex>
                                            {formData.slackAttributes.map(
                                                (attr, index) => (
                                                    <Flex
                                                        key={index}
                                                        gap="size-200"
                                                        marginY="size-100"
                                                        alignItems="center"
                                                    >
                                                        <TextField
                                                            width="40%"
                                                            value={attr.attributeName}
                                                            onChange={(v) =>
                                                                handleAttributeChange(index, 'attributeName', v, 'slack')
                                                            }
                                                        />
                                                        <Picker
                                                            width="40%"
                                                            selectedKey={attr.attributeValue}
                                                            onSelectionChange={(v) =>
                                                                handleAttributeChange(index, 'attributeValue', v, 'slack')
                                                            }
                                                        >
                                                            {attributesDropdown.map((dropdownAttr) => (
                                                                <Item key={dropdownAttr.attributeValue}>{dropdownAttr.attributeValue}</Item>
                                                            ))}
                                                        </Picker>
                                                        <Button
                                                            variant="secondary"
                                                            onPress={() =>
                                                                handleRemoveAttribute(index, 'slack')
                                                            }
                                                            UNSAFE_style={{
                                                                border:
                                                                    "transparent",
                                                                minWidth:
                                                                    "32px",
                                                                height: "32px",
                                                                padding: 0,
                                                            }}
                                                            aria-label="Remove attribute"
                                                        >
                                                            <Close
                                                                UNSAFE_style={{
                                                                    transform:
                                                                        "scale(0.8)",
                                                                }}
                                                            />
                                                        </Button>
                                                    </Flex>
                                                )
                                            )}

                                            <Button
                                                variant="primary"
                                                marginTop="size-200"
                                                marginBottom="size-300"
                                                onPress={() => handleAddAttribute('slack')}
                                            >
                                                Add Slack Attribute
                                            </Button>

                                            <TextArea
                                                label="Slack closing statement"
                                                value={
                                                    formData.slackClosingStatement
                                                }
                                                onChange={(v) =>
                                                    handleInputChange(
                                                        "slackClosingStatement",
                                                        v
                                                    )
                                                }
                                                width="100%"
                                            />
                                            <Divider size="S" marginTop="size-300" marginBottom="size-200" />
                                            <Flex alignItems="center" gap="size-200" marginBottom="size-200">
                                                <Text>Reply in Slack thread</Text>
                                                <Switch
                                                    isSelected={formData.slackReply}
                                                    onChange={(v) => handleInputChange("slackReply", v)}
                                                />
                                            </Flex>
                                            {formData.slackReply && (
                                                <TextArea
                                                    label="Slack reply message"
                                                    value={formData.slackReplyMessage}
                                                    onChange={(v) => handleInputChange("slackReplyMessage", v)}
                                                    width="100%"
                                                />
                                            )}
                                        </View>
                                    </>
                                )}
                            </View>

                            <View flex="1" minWidth="300px">
                                <View
                                    padding="size-400"
                                    borderRadius="medium"
                                    marginBottom="size-400"
                                    UNSAFE_style={{
                                        backgroundColor: "white",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                    }}
                                >
                                    <Flex
                                        alignItems="center"
                                        gap="size-200"
                                        marginBottom="size-300"
                                    >
                                        <EmailIcon />
                                        <Heading level={4} margin={0}>
                                            Email Template Preview
                                        </Heading>
                                    </Flex>
                                    <Divider size="S" marginBottom="size-300" />
                                    <Content>
                                        <Well>
                                            <Text>
                                                <strong>Subject:</strong>{" "}
                                                {formData.subject}
                                            </Text>
                                            <br />
                                            <br />
                                            {templateType === "common" ? (
                                                <Text>
                                                    {formData.openingStatement}
                                                </Text>
                                            ) : (
                                                <Text>
                                                    {formData.emailOpeningStatement}
                                                </Text>
                                            )}
                                            <br />
                                            {templateType === "common"
                                                ? formData.attributes.map(
                                                      (attr, i) => (
                                                          <React.Fragment
                                                              key={i}
                                                          >
                                                              {attr.attributeName && (
                                                                  <>
                                                                      <Text>
                                                                          {attr.attributeName}: {attr.attributeValue}
                                                                      </Text>
                                                                      <br />
                                                                  </>
                                                              )}
                                                          </React.Fragment>
                                                      )
                                                  )
                                                : formData.emailAttributes.map(
                                                      (attr, i) => (
                                                          <React.Fragment
                                                              key={i}
                                                          >
                                                              {attr.attributeName && (
                                                                  <>
                                                                      <Text>
                                                                          {attr.attributeName}: {attr.attributeValue}
                                                                      </Text>
                                                                      <br />
                                                                  </>
                                                              )}
                                                          </React.Fragment>
                                                      )
                                                  )}
                                            <br />
                                            {templateType === "common" ? (
                                                <Text>
                                                    {formData.closingStatement}
                                                </Text>
                                            ) : (
                                                <Text>
                                                    {formData.emailClosingStatement}
                                                </Text>
                                            )}
                                        </Well>
                                    </Content>
                                </View>

                                <View
                                    padding="size-400"
                                    borderRadius="medium"
                                    UNSAFE_style={{
                                        backgroundColor: "white",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                    }}
                                >
                                    <Flex
                                        alignItems="center"
                                        gap="size-200"
                                        marginBottom="size-300"
                                    >
                                        <SlackIcon />
                                        <Heading level={4} margin={0}>
                                            Slack Template Preview
                                        </Heading>
                                    </Flex>
                                    <Divider size="S" marginBottom="size-300" />
                                    <Content>
                                        <Well>
                                            {templateType === "common" ? (
                                                <Text>
                                                    {formData.openingStatement}
                                                </Text>
                                            ) : (
                                                <Text>
                                                    {formData.slackOpeningStatement}
                                                </Text>
                                            )}
                                            <br />
                                            {templateType === "common"
                                                ? formData.attributes.map(
                                                      (attr, i) => (
                                                          <React.Fragment
                                                              key={i}
                                                          >
                                                              {attr.attributeName && (
                                                                  <>
                                                                      <Text>
                                                                          {attr.attributeName}: {attr.attributeValue}
                                                                      </Text>
                                                                      <br />
                                                                  </>
                                                              )}
                                                          </React.Fragment>
                                                      )
                                                  )
                                                : formData.slackAttributes.map(
                                                      (attr, i) => (
                                                          <React.Fragment
                                                              key={i}
                                                          >
                                                              {attr.attributeName && (
                                                                  <>
                                                                      <Text>
                                                                          {attr.attributeName}: {attr.attributeValue}
                                                                      </Text>
                                                                      <br />
                                                                  </>
                                                              )}
                                                          </React.Fragment>
                                                      )
                                                  )}
                                            <br />
                                            {templateType === "common" ? (
                                                <Text>
                                                    {formData.closingStatement}
                                                </Text>
                                            ) : (
                                                <Text>
                                                    {formData.slackClosingStatement}
                                                </Text>
                                            )}
                                            {formData.slackReply && (
                                                <>
                                                    <br />
                                                    <br />
                                                    <Text>
                                                        <strong>Reply:</strong>{" "}
                                                        {formData.slackReplyMessage}
                                                    </Text>
                                                </>
                                            )}
                                        </Well>
                                    </Content>
                                </View>
                            </View>
                        </Flex>
                    </Flex>
                </Content>
            </Dialog>
        </DialogTrigger>
    )
}

export default CustomTemplate
